import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/performance_metrics_grid_data_actions';
import * as utilityHelpers from './shared/UtilityHelper';
import { default as PerformanceMetricsList } from "./PerformanceMetricsList";
import moment from "moment-timezone";

export class PerformanceMetricsFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filtered: [],
      filterExpanded: false,
      disableFilterHeaderClick: false,
      filterCleared: false,
      filterDisplayed: 'ManagementUnit',
      filterHeaderCount: false,
      count: '',
      MUAppliedSelections: [],
      AgentAppliedSelections: [],
      TeamAppliedSelections: []
    };

    this.FilterFields = [
      { key: 'ManagementUnit', label: "Management Unit", name: 'ManagementUnit', selectedName: 'ManagementUnitSelected', filterHeaderCount: 'MUFilterHeaderCount'},
      { key: 'Team', label: "Team", name: 'Team', selectedName: 'TeamSelected', filterHeaderCount: 'TeamFilterHeaderCount' },
      { key: 'Agent', label: "Agent", name: 'Agent', selectedName: 'AgentSelected', filterHeaderCount: 'AgentFilterHeaderCount'},      
    ]

    this.buildFilters = this.buildFilters.bind(this);
    this.filterClick = this.filterClick.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.selectFilter = this.selectFilter.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilterClear = this.resetFilterClear.bind(this);
    this.addFilterHeaderCount = this.addFilterHeaderCount.bind(this);
    this.removeFilterHeaderCount = this.removeFilterHeaderCount.bind(this);
    this.filterApplied = this.filterApplied.bind(this);
    this.setUserToSelectedItemCache = this.setUserToSelectedItemCache.bind(this);
    this.startPoll = this.startPoll.bind(this);
  }
  
  componentWillReceiveProps(nextProps) {
    
    if(this.props && (this.props.Items !== nextProps.Items)) {

      if(nextProps.Items.mu.length === 0 && nextProps.Items.agent.length === 0 && nextProps.Items.team.length === 0) {
        this.clearFilters()
      }
      else {
      this.setState({ 
        MUAppliedSelections: nextProps.Items.mu, 
        TeamAppliedSelections: nextProps.Items.team, 
        AgentAppliedSelections: nextProps.Items.agent
        }, function () {
          this.applyFilters(nextProps.Items.expirationDate);
        });
      }
    }
  }

  filterApplied(appliedSelections, section) {
    if(section === 'ManagementUnit') {
      this.setState({ MUAppliedSelections: appliedSelections })
    } else if(section === 'Agent') {
      this.setState({ AgentAppliedSelections: appliedSelections })
    } else if(section === 'Team') {
      this.setState({ TeamAppliedSelections: appliedSelections })
    }
  }

  resetFilterClear() {
    this.setState({ filterCleared: false })
  }
  
  filterClick() {
    this.setState({ 
      filterExpanded: !this.state.filterExpanded,
      disableFilterHeaderClick: !this.state.disableFilterHeaderClick
    });
  }

  addFilterHeaderCount(count, filterhdr, filterHeaderCount) {
    count = count+1;

    if(count > 0) {
      this.setState({ [filterHeaderCount]: true, [filterhdr]: count })
    }
  }

  removeFilterHeaderCount(count, filterhdr, filterHeaderCount) {
    count = count-1;
    
    if(count === 0) {
      this.setState({ [filterHeaderCount]: false, [filterhdr]: count })
    } else {
      this.setState({ [filterHeaderCount]: true, [filterhdr]: count })
    }
  }

  buildFilters() {
    let { filterDisplayed, disableFilterHeaderClick } = this.state;
    return this.FilterFields.map((filterField, index) => {
      let countText;
      this.state[filterField.selectedName] < 2 ? countText = '' : countText = "s";
      return (
        <div className={filterDisplayed === filterField.name ? "filter__sections filter__sections-selected" : 'filter__sections'} key={index}>
          <div className="filter__section">
            <div className={ disableFilterHeaderClick ? "filter__hdr" : "filter__hdr filter__hdr-cursor"} onClick={disableFilterHeaderClick ? null : () => this.filterClick()}>
              <span>
                { this.state[filterField.filterHeaderCount] && this.state[filterField.selectedName] ? this.state[filterField.selectedName] + " " + filterField.label + countText : "- Select " + filterField.label + "(s) to View -" }
              </span>
            </div>
            <div className="search__content">
              <div className="container">
                <section className="section__content">
                  <PerformanceMetricsList
                    items={filterField.name} 
                    selectedName={filterField.selectedName}
                    filterHeaderCount={filterField.filterHeaderCount}
                    filterCleared={this.state.filterCleared}
                    resetFilterClear={this.resetFilterClear}
                    addFilterHeaderCount={this.addFilterHeaderCount}
                    removeFilterHeaderCount={this.removeFilterHeaderCount}
                    filterApplied={this.filterApplied}
                  />
                </section>
              </div>
            </div>
          </div>
        </div>
      )
    })
  }

  clearFilters() {

    let _muSelections = [];
    let _agentSelections = [];
    let _teamSelections = [];

    this.setState({ 
      filterCleared: true,
      MUAppliedSelections: _muSelections,
      AgentAppliedSelections: _agentSelections,
      TeamAppliedSelections: _teamSelections
    });

    //reset supervisor to scorecard cache
    this.setUserToSelectedItemCache(_muSelections, _teamSelections, _agentSelections);
    
    //reset user selected items
    let scorecardSelectionKey = utilityHelpers._retrieveStorageKey(this.props.User)
    delete localStorage[scorecardSelectionKey];
    if(localStorage.sort !== undefined) {
      delete localStorage.sort;
    }

    this.FilterFields.map((filterField, index) => (
      this.setState({ [filterField.filterHeaderCount]: false })
    ));
    
    if(this.props.actions.clearFilterAction) {
      this.props.actions.clearFilterAction()
    }
  }

  selectFilter(filterField) {
    this.setState({ filterDisplayed: filterField.name });
  }

  componentWillUnmount() {
      clearTimeout(this.timeout);
  }
  
  startPoll() {
    //every 15 minutes, send snapshot of user selected items to redis
    this.timeout = setTimeout(() => this.setUserToSelectedItemCache(this.state.MUAppliedSelections, this.state.TeamAppliedSelections, this.state.AgentAppliedSelections), 900000);
  }

  setUserToSelectedItemCache(MUAppliedSelections, TeamAppliedSelections, AgentAppliedSelections) {
    
    clearTimeout(this.timeout);

    if(this.props.actions.updateUserToSelectedItemCacheAction) {
      let _username = this.props.User ? this.props.User.userName : null;
      if(_username) {
        var _muIds = [];
        if(MUAppliedSelections) {
          MUAppliedSelections.map(obj => { 
            _muIds.push(obj.key);
            return obj.key
          });
        }

        var _agentIds = [];
        if(AgentAppliedSelections) {
          AgentAppliedSelections.map(obj => { 
            _agentIds.push(obj.key);
            return obj.key
          });
        }

        var _teamIds = [];
        if(TeamAppliedSelections) {
          TeamAppliedSelections.map(obj => { 
            _teamIds.push(obj.key);
            return obj.key
          });
        }
        
        let _data = {
          Data: {
            'UserName': _username,
            'ManagementUnitIDs': _muIds,
            'TeamIDs': _teamIds,
            'AgentIDs': _agentIds
          }
        }
        this.props.actions.updateUserToSelectedItemCacheAction(_data);
        this.startPoll();
      }
    }
  }

  applyFilters(expirationDate = undefined) {
    let { MUAppliedSelections, TeamAppliedSelections, AgentAppliedSelections } = this.state;
    
    //notify subscribers of selected items
    if(this.props.actions.notifySubscribersOfSelectedItems) {
      this.props.actions.notifySubscribersOfSelectedItems(MUAppliedSelections, TeamAppliedSelections, AgentAppliedSelections);
    }

    //set supervisor to scorecard cache. it is used to help determine who is viewing what card, in order to push the respective update
    this.setUserToSelectedItemCache(MUAppliedSelections, TeamAppliedSelections, AgentAppliedSelections);
    
    if(MUAppliedSelections.length > 0 || TeamAppliedSelections.length > 0 || AgentAppliedSelections.length > 0) {
      if(this.props.actions.applyFilterAction) {
        this.props.actions.applyFilterAction();
      }
    } else {
      if(this.props.actions.clearFilterAction) {
        this.props.actions.clearFilterAction()
      }
    }

    this.setState({ 
      filterExpanded: false,
      disableFilterHeaderClick: false
    });

    //set local storage of user selected items
    let scorecardSelectionKey = utilityHelpers._retrieveStorageKey(this.props.User);
    
    let objectToStore = {
      mu: MUAppliedSelections,
      team: TeamAppliedSelections,
      agent: AgentAppliedSelections
    };

    if(expirationDate) {
      objectToStore["expirationDate"] = expirationDate;
    }
    else {
      let _expirationDate = moment().add(7, 'days');
      objectToStore["expirationDate"] = _expirationDate;
    }
    
    localStorage.setItem(scorecardSelectionKey, JSON.stringify(objectToStore));
  }

  render() {
    let { filterExpanded } = this.state;
    let { isTablet } = this.props;    
    return (
      <div className="filter__container" id="filter__container">
        <div className={ filterExpanded ? "filter filter__expanded" : "filter" }>
          <div className="filter__wrap">
            { this.buildFilters() }
            <div className="filter__clear-apply">
              { filterExpanded || isTablet ? 
                <div className="filter__apply" onClick={() => this.applyFilters()}>Apply Filters</div>
                :
                ""
              }
              <div className="filter__clear" onClick={() => this.clearFilters()}>Clear Filters</div>
            </div>
            {isTablet ? 
            <div className="filter__select-box">
              <div className="filter__title">Filters</div>
              {this.FilterFields.map((filterField, index) => (
                <div key={index} className="filter__select-boxes" onClick={() => this.selectFilter(filterField)}>
                  <div>- Select {filterField.label}(s) to View -</div>
                  <div className="sp-portal dd-arrow-filter"></div>
                </div>
              ))}
            </div>
            : null }
          </div>
          <div className="filter__wrap-right">
            {/* <div className={ filterExpanded ? "filter__close-wrap" : "filter__icon-wrap" } onClick={() => this.filterClick()}>
              { isTablet ? null : 
                <div className={ filterExpanded ? "sp-portal filter__close" : "sp-portal filter__icon" }></div>
              }
            </div>  */}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isTablet: state.common.isTablet,
    User: state.common.user,
    Items: state.scorecard.items
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetricsFilter);



// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetricsFilter.js